import axios, {AxiosResponse} from 'axios'
import {ID, QueryState, Response} from '../../../../_metronic/helpers'
import {ResponseTask, Task, TasksQueryResponse} from './_models'
import {
  ResponseTaskAttachement,
  TaskAttachement,
} from '../../project/components/tasks-list/TaskAttachment/core/_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_TASK_URL = `${API_URL}/api/tarefas`
const GET_TASKATTACHEMENT_URL = `${API_URL}/api/tarefas/anexo`

const getTaskById = (id: ID): Promise<ResponseTask> => {
  return axios
    .get(`${GET_TASK_URL}/${id}`)
    .then((response: AxiosResponse<ResponseTask>) => response.data)
}

const updateNameTask = (task_id: ID, query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/${task_id}/${query}/updatenamecell`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const updateStatusTask = (task_id: ID, query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/${task_id}/${query}/updatestatuscell`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const createTask = (task: Task): Promise<ResponseTask | undefined> => {
  return axios
    .post(`${GET_TASK_URL}/novo`, task)
    .then((response: AxiosResponse<ResponseTask>) => response.data)
}

const cloneTask = (task: Task): Promise<ResponseTask | undefined> => {
  return axios
    .post(`${GET_TASK_URL}/clone-task`, task)
    .then((response: AxiosResponse<ResponseTask>) => response.data)
}

const updateTask = (task: Task): Promise<ResponseTask> => {
  return axios
    .put(`${GET_TASK_URL}/${task.id}/editar`, task)
    .then((response: AxiosResponse<Response<ResponseTask>>) => response.data)
    .then((response: Response<ResponseTask>) => response.data)
}

const getTasksByUserId = (userId: ID, query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/${userId}/get-tasks-by-user-id?${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const getTasksCloseByUserId = (userId: ID, query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/${userId}/get-tasks-close-by-user-id?${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const getTasksByCreatorId = (query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/by-creatorid?${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const deliveryTask = (taskId: ID): Promise<ResponseTask> => {
  return axios
    .get(`${GET_TASK_URL}/${taskId}/delivery-task`)
    .then((d: AxiosResponse<ResponseTask>) => d.data)
}

const deliveryTaskPartial = (taskId: ID): Promise<ResponseTask> => {
  return axios
    .get(`${GET_TASK_URL}/${taskId}/delivery-task?partial=1`)
    .then((d: AxiosResponse<ResponseTask>) => d.data)
}

const reopenTaskMyPart = (taskId: ID): Promise<ResponseTask> => {
  return axios
    .get(`${GET_TASK_URL}/${taskId}/reopen-my-part`)
    .then((d: AxiosResponse<ResponseTask>) => d.data)
}

const deleteTask = (taskId: ID): Promise<void> => {
  return axios.delete(`${GET_TASK_URL}/${taskId}/excluir`).then(() => {})
}

const deleteSelectedTasks = (taskIds: Array<ID>): Promise<void> => {
  const requests = taskIds.map((id) => axios.delete(`${GET_TASK_URL}/${id}`))
  return axios.all(requests).then(() => {})
}
const searchTask = (userId: ID, search: string): Promise<TasksQueryResponse> => {
  let formData = new FormData()

  formData.append('search', search)
  formData.append('userId', userId?.toString()!)

  return axios
    .post(`${GET_TASK_URL}/search-my-tasks`, formData)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const getAttachements = (id: ID): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASKATTACHEMENT_URL}/${id}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const createTaskAttachement = (
  taskAttachement: TaskAttachement
): Promise<ResponseTaskAttachement> => {
  let formData = new FormData()
  if (taskAttachement.file) {
    formData.append('file', taskAttachement.file)
  }
  if (taskAttachement.task_id) {
    formData.append('task_id', taskAttachement.task_id.toLocaleString())
  }
  return axios
    .post(`${GET_TASKATTACHEMENT_URL}/novo`, formData)
    .then((response: AxiosResponse<ResponseTaskAttachement>) => response.data)
    .catch((error) => {
      // Se a resposta contém dados de erro estruturados, retorna eles
      if (error.response && error.response.data) {
        return Promise.reject(error.response.data)
      }
      // Caso contrário, rejeita com o erro original
      return Promise.reject(error)
    })
}

const deleteAttachement = (attachementid: ID): Promise<void> => {
  return axios.delete(`${GET_TASKATTACHEMENT_URL}/${attachementid}/excluir`).then(() => {})
}

const playTimeTracking = (taskId: ID): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/${taskId}/timetracking/start`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const stopTimeTracking = (taskId: ID, targetUserId?: ID): Promise<TasksQueryResponse> => {
  const query = targetUserId ? `?target_user_id=${targetUserId}` : ''
  return axios
    .get(`${GET_TASK_URL}/${taskId}/timetracking/stop${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const getKanbanTasks = (query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}/kanban-tasks?${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const updateStageUser = (task_id: ID, stageName: string, order: number, userId?: number): Promise<TasksQueryResponse> => {
  return axios
    .put(`${GET_TASK_URL}/${task_id}/stage/${stageName}/order/${order}`, {userId})
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

const getAllTasksByUserId = (userId: ID): Promise<{data: Task[]}> => {
  return axios
    .get(`${GET_TASK_URL}/${userId}/all-by-user`)
    .then((response: AxiosResponse<{data: Task[]}>) => response.data)
}

const getSubtasksByParentId = (parentId: ID, userId: ID): Promise<TasksQueryResponse> => {
  const params = new URLSearchParams()
  if (parentId !== null && parentId !== undefined) {
    params.append('parent_id', parentId.toString())
  }
  return axios
    .get(`${GET_TASK_URL}/${userId}/get-tasks-by-user-id?${params.toString()}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

export {
  deleteTask,
  deleteSelectedTasks,
  getTaskById,
  createTask,
  updateTask,
  deliveryTask,
  deliveryTaskPartial,
  reopenTaskMyPart,
  cloneTask,
  searchTask,
  getTasksByUserId,
  getTasksCloseByUserId,
  getTasksByCreatorId,
  getAttachements,
  deleteAttachement,
  updateNameTask,
  playTimeTracking,
  stopTimeTracking,
  createTaskAttachement,
  updateStatusTask,
  getKanbanTasks,
  updateStageUser,
  getAllTasksByUserId,
  getSubtasksByParentId
}
